module.exports = __webpack_public_path__ + "img/DE02611.c62be1be.png";